// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* CrewManifest.css */
.crew-manifest {
    padding: 2rem;
    background: #e6f7ff;
    max-width: 600px;
    margin: auto;
    border-radius: 8px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/CrewPassenger/CrewManifest.css"],"names":[],"mappings":";AACA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["\n/* CrewManifest.css */\n.crew-manifest {\n    padding: 2rem;\n    background: #e6f7ff;\n    max-width: 600px;\n    margin: auto;\n    border-radius: 8px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
